export enum TaskTypes {
  WELCOME = "WELCOME",
  TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS",
  AI_CONFIRMATION = "AI_CONFIRMATION",
}
